<template>
  <section>
    <div class="location" v-for="location in locations" :key="location.name">
      <div class="info" v-if="location.name != null">
        <div class="name">
          <span class="first-letter">{{ location.name.substr(0, 1) }}</span>
          {{ location.name.substr(1) }}
        </div>
        <div>{{ location.description }}</div>
      </div>
      <div class="divider" v-if="location.name != null" />
      <div class="property">
        <div>
          <img src="../assets/address.svg" />
          <span>{{ location.address }}</span>
        </div>
        <div>
          <img src="../assets/phone.svg" />
          <span>{{ location.phone }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    locations: Array
  }
};
</script>

<style lang="scss" scoped>
.location {
  border-top: 1px solid #c6c6c6;
  font-weight: bold;
  color: #6c6c6c;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 15px 0;

  &:first-child {
    border-top: none;
  }

  &:nth-child(even) {
    .info {
      border-right-color: #c4cb7a;
    }
  }

  .info {
    font-size: 16px;
    border-right: 1px solid #f6e699;
    padding-right: 15px;
    margin-right: 15px;

    .name {
      font-size: 18px;
      .first-letter {
        font-size: 36px;
      }
    }
  }

  .property {
    font-size: 16px;
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-gap: 15px;

    img {
      display: block;
      float: left;
      margin-right: 10px;
    }
  }
}

@media (max-width: 1023px) {
  .info {
    font-size: 14px !important;
    padding-right: 10px !important;
    margin-right: 10px !important;
    .name {
      font-size: 14px !important;
      .first-letter {
        font-size: 22px !important;
      }
    }
  }

  .property {
    font-size: 14px !important;
  }
}
</style>
